import { Component } from "@angular/core";
import { BaseHttpService } from "../../services/basehttp.service";
import { Constants } from "../../constants";
import { NotificationService } from "../../services/notifications.service";

@Component({
    selector: 'app-help',
    templateUrl: './helpcomponent.html',
    styleUrl: './helpcomponent.scss',
    standalone: false
})
export class HelpComponent {
    constant: Constants = new Constants();
    email: string = 'RA-PWODPPBC@pa.gov'


    constructor(private httpService: BaseHttpService, private notificationService: NotificationService) {

    }

    downloadDataFile = (documentType: string) => {
        this.httpService
            .get(
                `${this.constant.DownloadResourceByDocumentType}/${documentType}`
            )
            .subscribe(
                (response: any) => {
                    if (response) {
                        //console.log("response", response);
                        let url = response.url;
                        const validatedUrl = new URL(url);
                        if (
                            validatedUrl.protocol === "http:" ||
                            validatedUrl.protocol === "https:"
                        ) {
                            const anchor = document.createElement("a");
                            anchor.href = validatedUrl.toString();
                            anchor.target = "_blank";
                            anchor.click();
                        }
                    }
                },
                (error: any) => {
                    //console.log("Error: ", error);
                    this.notificationService.showError( error.error ?? "Error downloading file","Error");
                },
                () => {
                    //setShowConfirmDialog(false);
                }
            );
    };
}